import { MainLayoutSection } from 'presentation/ui/layouts/main-layout/main-layout-section/MainLayoutSection';
import { MainLayoutSectionSection } from 'presentation/ui/layouts/main-layout/main-layout-section/MainLayoutSectionSection';
import { ViewLayout } from 'presentation/ui/layouts/view-layout/ViewLayout';
import { ViewLayoutSection } from 'presentation/ui/layouts/view-layout/view-layout-section/ViewLayoutSection';
import { useContext } from 'react';
import { useTypedSelector } from '../../../../store/common/TypedSelector';
import { ClientContext } from '../../../core/context/ClientContext';
import { FacilityContext } from '../../../core/context/FacilityContext';
import { ContainerViewModel } from '../../domain/model/ContainerModel';
import { GeneratorEluateIsotope } from '../../domain/model/isotopes/GeneratorEluateIsotope';
import { GeneratorTypeIsotope } from '../../domain/model/isotopes/GeneratorTypeIsotope';
import { selectDispatchedContainers } from '../../store/containerSlice';
import { selectInWastemanagementCyclotronProducts } from '../../store/cyclotronProductSlice';
import { selectInWastemanagementEluates } from '../../store/eluateSlice';
import { selectGenerators } from '../../store/generatorSlice';
import { ContainerCollection } from '../ui/card-collections/container-collection/ContainerCollection';
import { ContainersByNuclide } from './ContainersByNuclideType';

export const DispatchedContainersView = (): JSX.Element => {

	 const clientContext = useContext(ClientContext);
	const facilityContext = useContext(FacilityContext);

	const dispatchedContainers = useTypedSelector(selectDispatchedContainers(
		clientContext.selectedClientUuid,
		facilityContext.selectedFacilityUuid
	));

	const inWastemanagementCyclotronProducts = useTypedSelector(selectInWastemanagementCyclotronProducts(
		clientContext.selectedClientUuid,
		facilityContext.selectedFacilityUuid
	));

	const inWastemanagementEluates = useTypedSelector(selectInWastemanagementEluates());

	const generators = useTypedSelector(selectGenerators(
		clientContext.selectedClientUuid,
		facilityContext.selectedFacilityUuid
	));

	inWastemanagementEluates.forEach(eluate => {

		const inWastemanagementEluateGenerator = generators.find((generator) => {
			return generator.Uuid === eluate.Generator;
		});
		if (inWastemanagementEluateGenerator.Isotope === GeneratorTypeIsotope.MOLYBDENUM_99_MO) {
			eluate.Isotope = GeneratorEluateIsotope.TECHNETIUM_99M_TC;
		} else {
			eluate.Isotope = GeneratorEluateIsotope.GALLIUM_68_GA;
		}
	});

	const containersByNuclides: Array<ContainersByNuclide> = [];
	let containersMixedNuclideIds: string[] = [];

	dispatchedContainers.forEach((dispatchedContainer: ContainerViewModel) => {

		if (dispatchedContainer.CyclotroneProductIds.length === 0 && dispatchedContainer.GeneratorEluatIds.length !== 0 ) {

			const dispatchedContainerEluates = inWastemanagementEluates.filter(value => dispatchedContainer.GeneratorEluatIds.includes(value.Uuid));
			// ToDo: Every return true if array is empty; it should be checked if the array is empty: alternate to every which checks for empty?
			// ToDo: Also possible: if around 63 with check if dispatchesContainerEluates
			const checkEluates = dispatchedContainerEluates.every((item) => {
				return item.Isotope === dispatchedContainerEluates[0].Isotope;
			});

			if (checkEluates) {
				const existingEluateContainerByNuclide = containersByNuclides.find((e) =>
					e.Nuclide === dispatchedContainerEluates[0].Isotope
				);
				if (existingEluateContainerByNuclide) {
					existingEluateContainerByNuclide.Containers.push(dispatchedContainer);
				} else {
					const newEluateContainerByNuclide: ContainersByNuclide = {
						Nuclide: dispatchedContainerEluates[0].Isotope,
						Containers: []
					};
					newEluateContainerByNuclide.Containers.push(dispatchedContainer);
					containersByNuclides.push(newEluateContainerByNuclide);
				}
			} else {
				const existingMixedContainerByNuclides = containersByNuclides.find((e) => e.Nuclide === 'GemischterContainer');
				if (existingMixedContainerByNuclides) {
					existingMixedContainerByNuclides.Containers.push(dispatchedContainer);
				} else {
					const newMixedContainerByNuclide: ContainersByNuclide = {
						Nuclide: 'GemischterContainer',
						Containers: []
					};
					newMixedContainerByNuclide.Containers.push(dispatchedContainer);
					containersByNuclides.push(newMixedContainerByNuclide);
				}
			}
		}

		if (dispatchedContainer.CyclotroneProductIds.length !== 0 && dispatchedContainer.GeneratorEluatIds.length === 0) {

			const dispatchedContainerCyclotronProducts = inWastemanagementCyclotronProducts.filter(
				value => dispatchedContainer.CyclotroneProductIds.includes(value.Uuid));
			const checkCyclotronProducts = dispatchedContainerCyclotronProducts.every((item) => {
				return item.Isotope === dispatchedContainerCyclotronProducts[0].Isotope;
			});
			if (checkCyclotronProducts) {
				const existingCyclotronProductContainerByNuclide = containersByNuclides.find(
					(e) => e.Nuclide === dispatchedContainerCyclotronProducts[0].Isotope);

				if (existingCyclotronProductContainerByNuclide) {
					existingCyclotronProductContainerByNuclide.Containers.push(dispatchedContainer);
				} else {
					const newCyclotronProductContainerByNuclide: ContainersByNuclide = {
						Nuclide: dispatchedContainerCyclotronProducts[0].Isotope,
						Containers: []
					};
					newCyclotronProductContainerByNuclide.Containers.push(dispatchedContainer);
					containersByNuclides.push(newCyclotronProductContainerByNuclide);
				}
			} else {
				const existingMixedContainerByNuclides = containersByNuclides.find((e) => e.Nuclide === 'GemischterContainer');
				if (existingMixedContainerByNuclides) {
					existingMixedContainerByNuclides.Containers.push(dispatchedContainer);
				} else {
					const newMixedContainerByNuclide: ContainersByNuclide = {
						Nuclide: 'GemischterContainer',
						Containers: []
					};
					newMixedContainerByNuclide.Containers.push(dispatchedContainer);
					containersByNuclides.push(newMixedContainerByNuclide);
				}
			}
		}

		if (dispatchedContainer.CyclotroneProductIds.length !== 0 && dispatchedContainer.GeneratorEluatIds.length !== 0) {
			containersMixedNuclideIds = containersMixedNuclideIds.concat(dispatchedContainer.GeneratorEluatIds, dispatchedContainer.CyclotroneProductIds);
			const existingMixedContainerByNuclides = containersByNuclides.find((e) => e.Nuclide === 'GemischterContainer');
			if (existingMixedContainerByNuclides) {
				existingMixedContainerByNuclides.Containers.push(dispatchedContainer);
			} else {
				const newMixedContainerByNuclide: ContainersByNuclide = {
					Nuclide: 'GemischterContainer',
					Containers: []
				};
				newMixedContainerByNuclide.Containers.push(dispatchedContainer);
				containersByNuclides.push(newMixedContainerByNuclide);
			}
		}
	});

	return (
		<MainLayoutSection section={MainLayoutSectionSection.SECTION_MAIN}>
			<ViewLayout>
				<ViewLayoutSection>
					<ContainerCollection containersByNuclides={containersByNuclides} />
				</ViewLayoutSection>
			</ViewLayout>
		</MainLayoutSection>
	);
};
